// Web stub for @react-native-firebase/auth
export const EmailAuthProvider = {
  credential: (email: string, password: string) => {
    return {
      providerId: 'password',
      email,
      password,
    };
  },
};

export const GoogleAuthProvider = {
  credential: (token: string) => {
    return {
      providerId: 'google.com',
      token,
    };
  },
};

export const AppleAuthProvider = {
  credential: (identityToken: string) => {
    return {
      providerId: 'apple.com',
      identityToken,
    };
  },
};

export default {
  EmailAuthProvider,
  GoogleAuthProvider,
  AppleAuthProvider,
};
